module.exports = __webpack_public_path__ + "static/media/SilverEdge.11bab6d4.png";